import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { clearClientSession } from '@/lib/clear-client-session'
import type { AuthState } from './types'

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,

      setAuth: ({ user, accessToken, refreshToken }) =>
        set({ user, accessToken, refreshToken }),

      clearAuth: () =>
        set({ user: null, accessToken: null, refreshToken: null }),

      logout: () => {
        get().clearAuth()
        clearClientSession()
      },

      isAuthenticated: () => Boolean(get().accessToken),
    }),
    {
      name: 'rsp-plus:auth',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
